import React, { useEffect, useRef, useState } from "react";
import "./MyProfileEdit.scss";
import UserRegistrationInputSecond from "../../../../../UserRegistration/components/UserregistrationInputSecond";
import UserRegistrationInputFirst from "../../../../../UserRegistration/components/UserRegistrationInputsFirst";
import ProfilePictureCompo from "../../../../../UserRegistration/components/ProfilePic/ProfilePic";
import { UserRegistrationInitialGetModel } from "../../../../../../models";
import { UserRegistrationService } from "../../../../../UserRegistration/UserRegistration.service";
import {
  contactData,
  contactDetails,
  userDetails,
  userDetailsValidationStatus,
  UserRegistrationInitialGetInterface,
  UserRegistrationInitialPostResponse,
  UserRegistrationInputFirstInputs,
  UserRegistrationInputSecondInputs,
} from "../../../../../UserRegistration/UserRegistration.models";
import { utilService } from "../../../../../../services";
import { useToast } from "@agney/ir-toast";
import Loader from "../../../../../../components/Shared/Loader/Loader";
import { CONSTANTS } from "../../../../../../constants/callcentral.constants";
import { dataTransferService } from "../../../../../../services/dataTransferService";
import { useTranslation } from "react-i18next";

interface MyProfileProps {
  onCancel: () => void;
}

const MyProfileEdit: React.FC<MyProfileProps> = (props) => {
  const Toast = useToast();
    const { t } = useTranslation("settings");
  const [isLoaderActive, setLoaderStatus] = useState(true);

  const [profilePicture, setProfilePicture] = useState<{ profilePic: string }>({
    profilePic: "",
  });

  const [initialGetData, setInitialGetData] =
    useState<UserRegistrationInitialGetModel>();

  const [postResult, setPostResult] =
    useState<UserRegistrationInitialPostResponse>();

  const validationKeeper = {
    firstName: {
      req: false,
    },
    lastName: {
      req: false,
    },
    userName: {
      req: false,
      exist: false,
      minLength: false,
    },
    password: {
      req: false,
      notStrong: false,
    },
    confirmPassword: {
      req: false,
      notMacth: false,
    },
  };
  const [validation, setValidation] =
    useState<userDetailsValidationStatus>(validationKeeper);

  const [typeValidation, settypeValidation] = useState<{
    primaryType: boolean;
    secondaryType: boolean;
  }>({ primaryType: false, secondaryType: false });

  const onPassword = () => {
    const re = new RegExp(
      "^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.+/,=_]).{8,}$"
    );

    const value = "" + userDetailsInput.password.current!.value;
    const isOk = re.test(value);
    if (!isOk) {
      validationKeeper.password.notStrong = true;
      setValidation(validationKeeper);
    } else {
      validationKeeper.password.notStrong = false;
      setValidation(validationKeeper);
    }
  };

  const onConfirmPassword = () => {
    if (
      userDetailsInput.password.current!.value ==
      userDetailsInput.confrimPassword.current!.value
    ) {
      validationKeeper.confirmPassword.notMacth = false;
      setValidation(validationKeeper);
    } else {
      validationKeeper.confirmPassword.notMacth = true;
      setValidation(validationKeeper);
    }
  };
  
  const onUsername = () => {};
  const onFirstname = () => {};
  const onLastName = () => {};

  const [contact, setContact] = useState<boolean>(false);

  const firstNameInputRef = useRef<HTMLIonInputElement>(null);
  const lastNameInputRef = useRef<HTMLIonInputElement>(null);
  const displayNameInputRef = useRef<HTMLIonInputElement>(null);
  const userNameInputRef = useRef<HTMLIonInputElement>(null);
  const passwordInputRef = useRef<HTMLIonInputElement>(null);
  const confirmPasswordInputRef = useRef<HTMLIonInputElement>(null);
  const networkInputRef = useRef<HTMLIonInputElement>(null);
  const emilInputRef = useRef<HTMLIonInputElement>(null);
  const pagerInputRef = useRef<HTMLIonInputElement>(null);
  const primaryPhoneInputRef = useRef<HTMLIonInputElement>(null);
  const secondaryPhoneInputRef = useRef<HTMLIonInputElement>(null);
  const perimaryPreferanceRef = useRef<HTMLIonSelectElement>(null);
  const secondaryPreferanceRef = useRef<HTMLIonSelectElement>(null);
  const emailPreferanceRef = useRef<HTMLIonSelectElement>(null);
  const pagerPreferanceRef = useRef<HTMLIonSelectElement>(null);
  const perimaryTypeRef = useRef<HTMLIonSelectElement>(null);
  const secondaryTypeRef = useRef<HTMLIonSelectElement>(null);
  const iAgreeTermsCheckBoxRef = useRef<HTMLInputElement>(null);
  const iAgreePrivacyCheckBoxRef = useRef<HTMLInputElement>(null);

  const paramsInitialGet = () => {
    return {
      reg_code: utilService.getNetwork(),
      guid: utilService.getLoggedUserGuid(),
    };
  };

  const inputData = {
    guid: paramsInitialGet().guid,
    firstName: initialGetData ? initialGetData!.firstName : "",
    lastName: initialGetData ? initialGetData!.lastName : "",
    displayName: "",
    userName: initialGetData ? initialGetData!.userName : "",
    password: "",
    confrimPassword: "",
    network: paramsInitialGet().reg_code,
    email: initialGetData ? initialGetData!.email : "",
    pager: initialGetData ? initialGetData!.pager : "",
    primaryPhone: "",
    primaryType: 0,
    secondPhone: "",
    secondType: 3,
    profile_pic: initialGetData ? initialGetData!.profile_pic : "",
    contactDetails: initialGetData ? initialGetData!.contactDetails : [],
    contact_preference: initialGetData
      ? initialGetData.contact_preference
      : { email: 0, pager: 0, alternate_number: 0, mobile_number: 0 },
  };

  const [inputUserDetails, setInputUserDetails] =
    useState<userDetails>(inputData);

  const [inputContactDetailsInit, setInputContactDetailsInit] = useState<
    contactDetails[]
  >(inputData.contactDetails);

  const [inputContactDetailsData, setInputContactDetailsData] =
    useState<contactData>(inputData);

  const userDetailsSubmit = () => {
    inputData.firstName = "" + userDetailsInput.firstName.current!.value;
    inputData.lastName = "" + userDetailsInput.lastName.current!.value;
    inputData.displayName = "" + userDetailsInput.displayName.current!.value;
    inputData.userName = "" + userDetailsInput.userName.current!.value;

    if (inputData.password) {
      inputData.password = "" + userDetailsInput.password.current!.value;
    }
    if (inputData.confrimPassword) {
      inputData.confrimPassword =
        "" + userDetailsInput.confrimPassword.current!.value;
    }
    inputData.network = "" + userDetailsInput.network.current!.value;
    inputData.profile_pic = profilePicture.profilePic;

    setInputUserDetails(inputData);
    setContact(true);
  };

  const contactDetailsBack = () => {
    inputData.email = "" + contactDetailsInput.email.current!.value;
    inputData.pager = "" + contactDetailsInput.pager.current!.value;
    inputData.primaryPhone =
      "" + contactDetailsInput.primaryPhone.current!.value;
    inputData.primaryPhone = inputData.primaryPhone.replace(/[^\d]/g, "");
    inputData.primaryType = +(
      "" + contactDetailsInput.primaryType.current!.value
    );
    inputData.secondPhone =
      "" + contactDetailsInput.secondryPhone.current!.value;
    inputData.secondPhone = inputData.secondPhone.replace(/[^\d]/g, "");
    inputData.secondType = +(
      "" + contactDetailsInput.secondryType.current!.value
    );
    inputData.contact_preference.email = +(
      "" + contactDetailsInput.emailPreferance.current!.value
    );
    inputData.contact_preference.pager = +(
      "" + contactDetailsInput.pagerPreferance.current!.value
    );
    inputData.contact_preference.mobile_number = +(
      "" + contactDetailsInput.primaryPreferance.current!.value
    );
    inputData.contact_preference.alternate_number = +(
      "" + contactDetailsInput.secondryPreferance.current!.value
    );
    setInputContactDetailsData(inputData);
    setContact(false);
  };
  const typeSavePrimary = (valuep: number, values: number) => {
    inputData.primaryType = valuep;
    inputData.secondType = values;
    setInputContactDetailsData(inputData);
  };

  const typeSaveSecondary = (valuep: number, values: number) => {
    inputData.secondType = values;
    inputData.primaryType = valuep;
    setInputContactDetailsData(inputData);
  };
  const save = () => {
    inputData.email = "" + contactDetailsInput.email.current!.value;
    inputData.pager = "" + contactDetailsInput.pager.current!.value;
    inputData.primaryPhone =
      "" + contactDetailsInput.primaryPhone.current!.value;
    inputData.primaryPhone = inputData.primaryPhone.replace(/[^\d]/g, "");
    inputData.primaryType = +(
      "" + contactDetailsInput.primaryType.current!.value
    );
    inputData.secondPhone =
      "" + contactDetailsInput.secondryPhone.current!.value;
    inputData.secondPhone = inputData.secondPhone.replace(/[^\d]/g, "");
    inputData.secondType = +(
      "" + contactDetailsInput.secondryType.current!.value
    );
    inputData.contact_preference.email = +(
      "" + contactDetailsInput.emailPreferance.current!.value
    );
    inputData.contact_preference.pager = +(
      "" + contactDetailsInput.pagerPreferance.current!.value
    );
    inputData.contact_preference.mobile_number = +(
      "" + contactDetailsInput.primaryPreferance.current!.value
    );
    inputData.contact_preference.alternate_number = +(
      "" + contactDetailsInput.secondryPreferance.current!.value
    );
    inputData.firstName = inputUserDetails.firstName;
    inputData.lastName = inputUserDetails.lastName;
    inputData.displayName = inputUserDetails.displayName;
    inputData.userName = inputUserDetails.userName;
    inputData.password = inputUserDetails.password;
    inputData.confrimPassword = inputUserDetails.confrimPassword;
    inputData.profile_pic = inputUserDetails.profile_pic;
    updateUserRegistration();
  };

  const userDetailsInput: UserRegistrationInputFirstInputs = {
    firstName: firstNameInputRef,
    lastName: lastNameInputRef,
    displayName: displayNameInputRef,
    userName: userNameInputRef,
    password: passwordInputRef,
    confrimPassword: confirmPasswordInputRef,
    network: networkInputRef,
  };

  const contactDetailsInput: UserRegistrationInputSecondInputs = {
    email: emilInputRef,
    pager: pagerInputRef,
    primaryPhone: primaryPhoneInputRef,
    secondryPhone: secondaryPhoneInputRef,
    primaryPreferance: perimaryPreferanceRef,
    secondryPreferance: secondaryPreferanceRef,
    primaryType: perimaryTypeRef,
    secondryType: secondaryTypeRef,
    iAgreeTerms: iAgreeTermsCheckBoxRef,
    iAgreePrivacy: iAgreePrivacyCheckBoxRef,
    pagerPreferance: pagerPreferanceRef,
    emailPreferance: emailPreferanceRef,
  };

  const loadUserRegistrationInitialGet = () => {
    userDetailsInput.firstName.current!.value = initialGetData
      ? initialGetData!.firstName
      : "";
    userDetailsInput.lastName.current!.value = initialGetData
      ? initialGetData!.lastName
      : "";
    userDetailsInput.userName.current!.value = initialGetData
      ? initialGetData!.userName
      : "";
    userDetailsInput.displayName.current!.value = initialGetData
      ? initialGetData!.displayName
      : "";
    setProfilePic(initialGetData ? initialGetData.profile_pic : "");
  };

  const fetchUserRegistrationInitialGet = async () => {
    setLoaderStatus(true);

    const respResult: UserRegistrationInitialGetInterface =
      await UserRegistrationService.userRegistrationInitialGet(
        paramsInitialGet()
      );
    respResult.isSuccess
      ? setInitialGetData(respResult.UserRegistrationIntialGet)
      : UserRegistrationService.handleErrorResponse();
    setLoaderStatus(false);
  };

  const updateUserRegistration = async () => {
    setLoaderStatus(true);
    const respResult: UserRegistrationInitialPostResponse =
      await UserRegistrationService.userRegistrationIntialPost(
        inputData,
        paramsInitialGet().reg_code
      );
    if (respResult.isSuccess) {
      setPostResult(respResult);
      contact && props.onCancel();
      dataTransferService.transferProfileUpdatedAction(true);
    } else {
  Toast.error(t("profileUpdateFailed"));
      UserRegistrationService.handleErrorResponse();
    }
    setLoaderStatus(false);
  };

  useEffect(() => {
    fetchUserRegistrationInitialGet();
  }, []);

  useEffect(() => {
    if (postResult?.isSuccess === true) {
      Toast.success(t("profileUpdatedSuccess"));
    }
  }, [postResult]);

  useEffect(() => {
    loadUserRegistrationInitialGet();
    setInputUserDetails(inputData);
    setInputContactDetailsInit(inputData.contactDetails);
    setInputContactDetailsData(inputData);
  }, [initialGetData]);

  const setProfilePic = (bPic: string) => {
    setProfilePicture({ profilePic: bPic });
  };

  return (
    <div className="ion-padding">
      <div className="reg-container">
        <div className="reg-input-container">
          <div className="profile-edit-back" onClick={props.onCancel}>
            <div className="profile-edit-back-icon icon-back"></div>
            <div className="profile-edit-back-header">  {t("editProfile")}</div>
          </div>
          <div className="profilepic-input-header-container">
            {!contact && (
              <ProfilePictureCompo
                key={profilePicture.profilePic}
                setProfilePic={setProfilePic}
                initValue={profilePicture.profilePic}
              ></ProfilePictureCompo>
            )}
          </div>
          <div className="login-input-wrapper">
            {isLoaderActive && (
              <div className="loader-container">
                <Loader></Loader>
              </div>
            )}
            {contact ? (
              <UserRegistrationInputSecond
                isTermsPrivacyActive={false}
                submitBtnMyProfile={true}
                typeSavePrimary={typeSavePrimary}
                typeSaveSecondary={typeSaveSecondary}
                inputs={contactDetailsInput}
                onBack={contactDetailsBack}
                onSave={save}
                inputData={inputContactDetailsData}
                contactDetails={inputContactDetailsInit}
                typeValidation={typeValidation}
                typePrimary={(value) => {
                  settypeValidation({
                    primaryType: value,
                    secondaryType: typeValidation.secondaryType,
                  });
                }}
                typesecodary={(value) => {
                  settypeValidation({
                    secondaryType: value,
                    primaryType: typeValidation.primaryType,
                  });
                }}
                phoneTypeMyProfile={true}
                displayMyProfileEdit={true}
              />
            ) : (
              <UserRegistrationInputFirst
                onUsername={onUsername}
                onFirstName={onFirstname}
                onLastName={onLastName}
                onPassword={onPassword}
                onConfirmPassword={onConfirmPassword}
                isPasswordActive={false}
                validation={validation}
                inputs={userDetailsInput}
                onNext={userDetailsSubmit}
                inputData={inputUserDetails}
                isDisabled={true}
                myProfNextBtn={true}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfileEdit;
